import { calendarStorySections } from './calendar';
import { displayStorySections } from './display';
import { feedbackStorySections } from './feedback';
import { formsStorySections } from './forms';
import { layoutStorySections } from './layout';
import { navigationStorySections } from './navigation';
import { overlayStorySections } from './overlays';
import { buildFamilyApi, validateFamilyApi } from './publicApi';

const componentCatalog = [
    ...calendarStorySections,
    ...displayStorySections,
    ...feedbackStorySections,
    ...formsStorySections,
    ...layoutStorySections,
    ...navigationStorySections,
    ...overlayStorySections
]
    .map(family => ({
        ...family,
        api: buildFamilyApi(family)
    }))
    .map(family => {
        validateFamilyApi(family);

        return family;
    })
    .sort((left, right) => left.label.localeCompare(right.label, undefined, { sensitivity: 'base' }));

export { componentCatalog };
